// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-06434a94]:export {\n  menuBg: #E25527;\n  menuText: #ffffff;\n  menuActiveText: #E25527;\n  menuActiveBg: #ffffff;\n}\n\n/* Mixins */\n.el-upload[data-v-06434a94] {\n  display: block;\n}\n.drag-icon[data-v-06434a94] {\n  font-size: 1.5em;\n  color: #999;\n}\n.cropper[data-v-06434a94] {\n  height: 800px;\n  background: #DDD;\n}", ""]);
// Exports
module.exports = exports;
